// Original, short Web Audio cues. No files, speech, recording, or automatic playback.
const cues = {
  checking: [
    [440, 0, 0.12],
    [554, 0.14, 0.13],
  ],
  positive: [
    [523.25, 0, 0.18],
    [659.25, 0.2, 0.22],
  ],
  attention: [
    [392, 0, 0.2],
    [329.63, 0.23, 0.17],
  ],
  recovery: [
    [440, 0, 0.16],
    [554.37, 0.18, 0.17],
    [659.25, 0.37, 0.22],
  ],
};
function createSoundEngine(
  factory = () => {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) throw new Error("Sound is unavailable in this browser.");
    return new AudioContext();
  },
) {
  let context = null,
    enabled = false,
    active = [],
    revision = 0;
  function stop() {
    for (const item of active) {
      try {
        item.oscillator.stop();
      } catch (_) {
        /* Already finished. */
      }
      item.oscillator.disconnect();
      item.gain.disconnect();
    }
    active = [];
  }
  return {
    async enable() {
      const request = ++revision;
      context = context || factory();
      await context.resume();
      if (request !== revision) return false;
      enabled = true;
      return true;
    },
    mute() {
      revision++;
      enabled = false;
      stop();
    },
    stop,
    play(name) {
      if (!enabled || !context || context.state !== "running" || !cues[name])
        return false;
      stop(); // A meaningful event replaces any unfinished cue, never overlaps it.
      const now = context.currentTime;
      for (const [frequency, offset, duration] of cues[name]) {
        const oscillator = context.createOscillator(),
          gain = context.createGain();
        oscillator.type = "sine";
        oscillator.frequency.value = frequency;
        gain.gain.setValueAtTime(0, now + offset);
        gain.gain.linearRampToValueAtTime(0.035, now + offset + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + duration);
        oscillator.connect(gain);
        gain.connect(context.destination);
        const item = { oscillator, gain };
        active.push(item);
        oscillator.onended = () => {
          oscillator.disconnect();
          gain.disconnect();
          active = active.filter((x) => x !== item);
        };
        oscillator.start(now + offset);
        oscillator.stop(now + offset + duration + 0.02);
      }
      return true;
    },
    dispose() {
      this.mute();
      if (context) context.close();
      context = null;
    },
  };
}
module.exports = { createSoundEngine, cues };
